/*
 * File: /src/router/routes/formFieldProfiles.js
 * Author: AdBase, Inc.
 * -----
 * Copyright (c) 2026 AdBase, Inc.
 */

const FormFieldProfileList = () =>
  import(
    /* webpackChunkName: "FormFieldProfiles" */ 'src/components/Dashboard/Views/FormFieldProfiles/FormFieldProfileList.vue'
  );
const FormFieldProfileEdit = () =>
  import(
    /* webpackChunkName: "FormFieldProfiles" */ 'src/components/Dashboard/Views/FormFieldProfiles/FormFieldProfileEdit.vue'
  );

export const formFieldProfileRoutes = [
  {
    path: 'form-field-profiles/list',
    name: 'Custom Field Profile List',
    component: FormFieldProfileList,
  },
  {
    path: 'form-field-profiles/edit/:id',
    name: 'Custom Field Profile Edit',
    component: FormFieldProfileEdit,
    props: (route) => ({
      id: parseInt(route.params.id),
    }),
  },
];
